import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { ModalBody } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import {  useNavigate  } from "react-router-dom";
import CustomModalMobileButton from '../CustomModalMobileButton.jsx';

function LogoutPopup(props) {
     
    const { t } = useTranslation();
    let navigate = useNavigate();
    const onClose = () => {
        props.setShow(false);
    }

    return (
        <Modal show={props.show}>
            <Modal.Header closeLabel={t('common.close')}>
                <Modal.Title className='long_alias'>{props.alias}</Modal.Title>
                <CustomModalMobileButton onShowHide={onClose} />
            </Modal.Header>
            <ModalBody>
                <Form>
                    <Form.Group className="mb-3" controlId="popupForm.ControlInput1">
                        <Form.Label>
                            {props?.isPreRegistration && props?.step == 2 ?  t('member.header.current_step_leave') : t('member.header.logoutConfirmationText') }
                        </Form.Label>
                    </Form.Group>
                </Form>
            </ModalBody>
            <Modal.Footer>
                <Button variant="secondary"
                    onClick={(e) => onClose()}
                >
                    {t('registration.buttons.no')}
                </Button>
                <Button variant="outline-danger"
                    onClick={(e) => {props?.isPreRegistration ? navigate('/') : props.logout(e)}}
                >
                    {t('registration.buttons.yes')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default LogoutPopup;